import { motion } from "framer-motion";
import { Target, TestTube, ChartBar, Rocket } from "lucide-react";

export const OptimizationProcess = () => {
  const steps = [
    {
      icon: <Target className="h-8 w-8 text-blue-500" />,
      title: "Analysis & Research",
      description: "Deep dive into your data to identify optimization opportunities and pain points."
    },
    {
      icon: <TestTube className="h-8 w-8 text-blue-500" />,
      title: "Hypothesis & Testing",
      description: "Develop and implement A/B tests based on research-backed hypotheses."
    },
    {
      icon: <ChartBar className="h-8 w-8 text-blue-500" />,
      title: "Data Collection",
      description: "Gather comprehensive data through various testing methods and analytics."
    },
    {
      icon: <Rocket className="h-8 w-8 text-blue-500" />,
      title: "Implementation",
      description: "Roll out winning variations and continue iterative improvement."
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Our Data-Driven Optimization Process
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We follow a systematic approach to optimize your conversion rates
            through careful analysis and continuous testing.
          </p>
        </motion.div>
        <div className="grid md:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="relative"
            >
              <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
                <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mb-6">
                  {step.icon}
                </div>
                <h3 className="text-xl font-semibold mb-3 text-gray-900">
                  {step.title}
                </h3>
                <p className="text-gray-600">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 right-0 transform translate-x-1/2 -translate-y-1/2">
                  <div className="w-8 h-0.5 bg-blue-200" />
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};